module.exports = __webpack_public_path__ + "img/196.aba95f32.jpg";